module.exports = __webpack_public_path__ + "img/wallet.03662db3.png";